import React from 'react';
import { Link } from 'react-router-dom';
import {makeStyles} from '@material-ui/styles';
import { ListItem, ListItemText, Box } from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        fontSize:'1rem',
        fontWeight:'400',
        padding: "4px 24px 8px 16px"
    }
})

function ListItemLink(props) {
    const {to, primary, secondary, onClickHandleClose, onClickHandleAction, disabled= false} = props
    const classes = useStyles();
    const renderLink = React.useMemo(
        () => React.forwardRef((linkProps, ref) => <Link ref={ref} to={to} {...linkProps} />), [to]
    );

    const onClickHandle =() =>{
        onClickHandleAction && onClickHandleAction();
        onClickHandleClose();
    }

    return (
        <ListItem
        disabled={disabled}
            className={classes.root} button component={to ? renderLink : 'div'}
            onClick={onClickHandle}>
            <Box
                pr={2}
                display='flex'
                justifyContent='center'
                alignItems='center'>
                <props.icon style={{ fontSize: '1rem' }} />
            </Box>
            <ListItemText
                primaryTypographyProps={{
                    style: {
                        fontSize: '1rem',
                        fontWeight: '400',
                    }
                }}
                primary={primary}
                secondary={secondary} />
        </ListItem>
    )
}

export default ListItemLink;